import { useRef, useEffect, useReducer, } from 'react'
import { getCancelToken, getLookup, isCancel, } from '../api/ApiBase'
import { AxiosError, AxiosResponse, CancelTokenSource } from 'axios'
import { type HookTypes } from '../types/util'
import { type Lookup } from '../types/api/Lookup'

function lookupReducer (
  state: HookTypes.LookupReducerState,
  action: HookTypes.LookupReducerActionType
) : HookTypes.LookupReducerState {
  if (!action) {
    return state
  }
  const { type, payload, } = action
  if (type) {
    switch(type) {
    case 'LOAD_START':
      return {
        ...state, 
        loading: true,
        lookup : [],
      }
    case 'LOAD_SUCCESS':
      return {
        ...state, 
        loading: false,
        lookup : payload.data,
      }
    case 'LOAD_FAIL':
      return {
        ...state, 
        loading: false,
        lookup : [],
      }
    default :
      return state
    }
  }
  return state
}


function useLookupFetch (endpoint : string): HookTypes.LookupFetchHookResultArray {
  const [ state, dispatch, ] = useReducer<HookTypes.LookupReducerType>(lookupReducer, { 
    loading: false, 
    lookup : [], 
  })
  const { loading, lookup, } = state
  const cancelToken = useRef<CancelTokenSource | null>(null)
  
  useEffect(() => {
    if (!endpoint) {
      return
    }
    
    const token = cancelToken
    dispatch({ type: 'LOAD_START', })
    
    function onFailure (error: AxiosError | Error) {
      if (!isCancel(error)) {
        dispatch({ type: 'LOAD_FAIL', })
      }
      token.current = null
    }
    
    function onSuccess (resp : AxiosResponse<Lookup[]>) {
      dispatch({ type: 'LOAD_SUCCESS', payload: { data: resp.data, }, })
      token.current = null
    }
    
    token.current = getCancelToken()
    getLookup(endpoint, onSuccess, onFailure, token.current)
    
    return () => {
      if (token && token.current) {
        token.current.cancel('Cancelling request due to unmount')
      }
    }
  }, [ endpoint, ])
  
  return [ loading, lookup, ]
}

export default useLookupFetch;